import { PlayerNumber } from '~/modules/players/player-number';

/**
 * How long a lead has to hold before the 1st tag moves to it. A close duel swaps the lead on
 * almost every note, and a tag that follows each swap flickers.
 */
export const LEAD_HOLD_MS = 1_000;

export interface LeadState {
  leader: PlayerNumber | null;
  since: number;
}

/**
 * Nobody wears the tag while the lead is unsettled - neither the singer who just lost it nor the
 * one who has not held it long enough to claim it.
 */
export const settleLead = (
  previous: LeadState | null,
  leader: PlayerNumber | null,
  now: number,
): { state: LeadState; settled: PlayerNumber | null } => {
  const state = previous && previous.leader === leader ? previous : { leader, since: now };

  return { state, settled: leader !== null && now - state.since >= LEAD_HOLD_MS ? leader : null };
};
